import {
  ColumnDef,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";

type SimpleTableProps<TData extends object> = {
  data: TData[];
  columns: ColumnDef<TData, unknown>[];
};

export const InlineTable = <TData extends object>({
  data,
  columns,
}: SimpleTableProps<TData>) => {
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <table className="w-full">
      <thead>
        {table.getHeaderGroups().map((headerGroup) => (
          <tr key={headerGroup.id}>
            {headerGroup.headers.map((header, index) => (
              <th
                key={header.id}
                className={
                  index === 0
                    ? "border border-gray-100 bg-gray-50 p-0"
                    : "border-b border-r border-t border-gray-100 bg-gray-50 p-0"
                }
              >
                <div className="flex h-8 items-center px-2 py-1.5">
                  <p className="overflow-hidden text-ellipsis whitespace-nowrap text-gray-800 font-inter-medium-12px">
                    {header.isPlaceholder
                      ? null
                      : flexRender(
                          header.column.columnDef.header,
                          header.getContext(),
                        )}
                  </p>
                </div>
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody>
        {table.getRowModel().rows.map((row) => (
          <tr key={row.id}>
            {row.getVisibleCells().map((cell, index) => (
              <td
                key={cell.id}
                className={
                  index === 0
                    ? "border-b border-l border-r border-gray-100 p-0"
                    : "border-b border-r border-gray-100 p-0"
                }
              >
                <div className="flex h-8 items-center px-1.5 py-1.5">
                  <div className="overflow-hidden text-ellipsis whitespace-nowrap text-gray-800 font-inter-normal-12px">
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </div>
                </div>
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
